// <cookie-preferences> reveals its button only when Shopify's cookie banner API is present and
// opens the consent preferences dialog on click (window.privacyBanner.showPreferences()).
class CookiePreferences extends HTMLElement {
  #tries = 0;

  connectedCallback() {
    this.querySelector('button')?.addEventListener('click', () => window.privacyBanner?.showPreferences?.());
    this.#check();
  }

  #check() {
    if (typeof window.privacyBanner?.showPreferences === 'function') {
      this.hidden = false;
      return;
    }
    // The banner script loads asynchronously; poll briefly, then give up (no banner configured).
    if (this.#tries++ < 20) setTimeout(() => this.#check(), 500);
  }
}

if (!customElements.get('cookie-preferences')) customElements.define('cookie-preferences', CookiePreferences);

